function render_GWP(){
  console.log('Render GWP Fires');
 const gwp_form = document.querySelector('.gwp-form');
console.log(gwp_form);
  if(gwp_form) {
const notification = document.getElementById('cart-notification');
gwp_form.addEventListener('submit', (e)=>{
  e.preventDefault();
  const variantid = gwp_form.querySelector('[name="id"]').value

  let formData = {
  'sections':['main-cart-footer','main-cart-items','gwp-main'],
  'sections_url': window.location.pathname,
 'items': [{
  'id': variantid,
  'quantity': 1,
   'properties':{
     '__type':'GWP'
   }
  }]
};
  fetch(`/cart/add.js`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then((response) => {
  return response.json();
}).then((response) => {
  console.log(response);
  updateGWP();
})
.catch((error) => {
  console.error('Error:', error);
});
})     
  }
}

function updateGWP() {
  console.log('Update GWP Fires');
  fetch(window.location)
  .then(data => {
    return data.text();
  })
  .then(html => {
    const pageHtml = new DOMParser().parseFromString(html, "text/html");
    const gwp_html = pageHtml.querySelector('#gwp');
    const cart_footer_html = pageHtml.querySelector('#main-cart-footer');
    const cart_items_html = pageHtml.querySelector('#main-cart-items');
    document.querySelector('#gwp').innerHTML = gwp_html.innerHTML;
    document.querySelector('#main-cart-footer').innerHTML = cart_footer_html.innerHTML;
    document.querySelector('#main-cart-items').innerHTML = cart_items_html.innerHTML;
    render_GWP();
  });
}


render_GWP();